/** RAG semantic colors — keep in sync with `:root` in index.css and API pulse/services/display_format.py */
export const RAG_RED = '#b00020';
export const RAG_AMBER = '#d99000';
export const RAG_GREEN = '#198754';

/** Decorative “gold” (VDR admin, key-task star) — not RAG amber */
export const BRAND_SECONDARY_HEX = '#c89741';
